import { TextValueType } from '../../../utils/constants';
import { get } from 'lodash';

export const AllowedFileTypes = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'png', 'jpeg', 'jpg', 'eml', 'zip', 'rar', '7z'];

export const AllowedFileTypesCombined = get(window, '_CMS_.ALLOWED_FILE_EXTENSIONS', []);

export const ProductTypeList = [
  'Accident & Health',
  'Business Pack',
  'Farm',
  'Home – Building & Contents',
  'Home – Building Only',
  'Home – Contents Only',
  'Landlord',
  'Lenders Mortgage Insurance',
  'Motor',
  'Motorcycle',
  'Residential Strata',
  'Other',
];
// Values for PEGA
// https://qbe-appservices.atlassian.net/wiki/spaces/CMS/pages/1902969208/Webform+to+Pega+CMS+mapping
export const ProductTypeListValues = [
  'Accident & Health',
  'Business Pack',
  'Farm',
  'Home',
  'Home',
  'Contents',
  'Landlords',
  'Lenders mortgage insurance',
  'Motor',
  'Motorcycle',
  'Residential Strata',
  'Other',
];

export const ComplimentAreaList = [
  'Assessment/Repair',
  'Documentation',
  'Financial Hardship',
  'Marketing',
  'Policy/Product',
  'Premium/Pricing',
  'Privacy',
  'Recovery',
  'Service',
];

export const SalesCategoryList: TextValueType[] = [
  {
    text: 'Policy/Product',
    value: 'PolicyProduct',
  },
  {
    text: 'Premium/Pricing',
    value: 'PremiumPricing',
  },
  {
    text: 'Documentation',
    value: 'Documentation',
  },
  {
    text: 'Privacy',
    value: 'Privacy',
  },
  {
    text: 'Marketing',
    value: 'Marketing',
  },
  {
    text: 'Service',
    value: 'SalesService',
  },
];

export const ClaimCategoryList: TextValueType[] = [
  {
    text: 'Assessment/Repair',
    value: 'AssessmentRepair',
  },
  {
    text: 'Denial',
    value: 'Denial',
  },
  {
    text: 'Settlement amount',
    value: 'SettlementAmount',
  },
  {
    text: 'Recovery',
    value: 'Recovery',
  },
  {
    text: 'Privacy',
    value: 'Privacy',
  },
  {
    text: 'Service',
    value: 'ClaimsService',
  },
  {
    text: 'Settlement method',
    value: 'SettlementMethod',
  },
];

export const FinancialHardshipCategoryList: TextValueType[] = [
  {
    text: 'Service',
    value: 'HardshipService',
  },
  {
    text: 'Outcome',
    value: 'Outcome',
  },
  {
    text: 'Privacy',
    value: 'Privacy',
  },
];
